/**
 * @description 航司二字码获取航司名称
 * @param {string} code
 */
export default function getAirlineName(code) {
    if (!code)
        return '';
    return ({
        CZ: '中国南方航空公司',
        MU: '中国东方航空公司',
        MF: '厦门航空有限公司',
        CA: '中国国际航空公司',
        HU: '海南航空股份有限公司',
        FM: '中国上海航空公司',
        OQ: '重庆航空',
        ZH: '深圳航空有限责任公司',
        GS: '天津航空有限责任公司',
        '3U': '四川航空股份有限公司',
        NS: '河北航空有限公司',
        G5: '华夏航空公司',
        KL: '荷兰皇家航空公司',
        AF: '法国航空公司',
        WS: '西捷航空公司',
        DL: '达美航空公司',
        KE: '大韩航空公司',
        OK: '捷克航空公司',
        JL: '日本航空公司',
        QF: '澳洲航空公司',
        SU: '俄罗斯国际航空公司',
        MX: '墨西哥航空公司',
        AZ: '意大利航空公司',
        PE: '欧罗巴航空公司',
        KQ: '肯亚航空公司',
        VN: '越南航空公司',
        RO: '罗马尼亚航空公司',
        CI: '中华航空公司',
        SV: '沙特阿拉伯航空公司',
        ME: '中东航空公司',
        AR: '阿根廷航空公司',
        GA: '嘉鲁达印尼航空公司',
        GJ: '长龙航空公司',
        OZ: '韩亚航空公司',
    }[code.substring(0, 2).toLocaleUpperCase()] ||
        code ||
        '');
}



//////////////////
// WEBPACK FOOTER
// ../emp-helpers/dist/es/business/getAirlineName.js
// module id = null
// module chunks = 